import 'Scripts/icheck-1.0.3/icheck.min.js';
import 'Scripts/icheck-1.0.3/skins/flat/blue.css';
import 'Scripts/icheck-1.0.3/skins/minimal/blue.css';
